module.exports = __webpack_public_path__ + "static/media/whatsapp_chat_icon.721abcd1.svg";